import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import NavigationalListComponent from "./component";
import { useNavigate } from "react-router-dom";

const NavigationalListContainer = (props) => {
  const navigate = useNavigate();
  const [navigationalList, setNavigationalList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("category");
  const [statusFilter, setStatusFilter] = useState("All");

  // S3 Base URL
  const S3_BASE_URL = "https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/";

  // Default images
  const DEFAULT_ICON = "https://cdn-icons-png.flaticon.com/512/1261/1261163.png";
  const DEFAULT_BACKGROUND = "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop";

  // Get user role from localStorage
  const user = JSON.parse(localStorage.getItem("data") || "{}");
  const userRole = user?.details?.userRole?.role_id;
  const canPerformActions = userRole !== 15;

  // Helper function to get full image URL
  const getFullImageUrl = (imagePath) => {
    if (!imagePath) return null;
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }
    return `${S3_BASE_URL}${imagePath}`;
  };

  // Search handler
  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  // Filter based on search and status
  useEffect(() => {
    let filtered = [...navigationalList];
    
    // Filter by search
    if (searchValue.trim()) {
      const searchString = searchValue.toLowerCase();
      if (activeTab === "category") {
        filtered = filtered.filter((item) => {
          const name = (item.name || "").toLowerCase();
          return name.includes(searchString);
        });
      } else {
        // For variant view, search in variant details
        filtered = filtered.filter((item) => {
          // Search in variant IDs and variant names from variantDetails
          if (item.variantDetails && item.variantDetails.length > 0) {
            return item.variantDetails.some(variant => 
              String(variant.id).toLowerCase().includes(searchString) ||
              (variant.name && variant.name.toLowerCase().includes(searchString))
            );
          }
          // Fallback to variantIds
          return (item.variantIds || []).some(vId => 
            String(vId).toLowerCase().includes(searchString)
          );
        });
      }
    }
    
    // Filter by status
    if (statusFilter !== "All") {
      filtered = filtered.filter((item) => item.status === statusFilter);
    }
    
    setFilteredList(filtered);
  }, [searchValue, navigationalList, activeTab, statusFilter]);

  // Fetch navigational data
  const fetchNavigationalData = () => {
    setLoading(true);

    props.getDataFromAPI(
      `/partner/api/v1/nav-categories`,
      "GET",
      undefined,
      (response) => {
        console.log("API Response:", response);
        
        let navData = [];

        if (response?.data && Array.isArray(response.data)) {
          navData = response.data;
        } else if (response && Array.isArray(response)) {
          navData = response;
        } else if (response?.content && Array.isArray(response.content)) {
          navData = response.content;
        }

        const formattedData = navData.map(item => ({
          id: item.id,
          name: item.name,
          description: item.description || "",
          status: item.active === true ? "Active" : "Inactive",
          iconUrl: getFullImageUrl(item.imagePath) || DEFAULT_ICON,
          backgroundUrl: getFullImageUrl(item.bgImagePath) || DEFAULT_BACKGROUND,
          mappingType: "Variant",
          variantCount: item.variantDetails?.length || item.variantIds?.length || 0,
          variantIds: item.variantIds || [],
          variantDetails: item.variantDetails || [], // This contains {id, name, image}
          createdAt: item.createdAt || new Date().toISOString(),
        }));

        setNavigationalList(formattedData);
        setFilteredList(formattedData);
        setLoading(false);
      },
      (err) => {
        console.log("Error fetching navigationals:", err);
        toastr.error("Failed", "Unable to fetch navigational list");
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchNavigationalData();
  }, []);

  // Tab change handler
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchValue("");
    setStatusFilter("All");
  };

  // Create new navigational
  const handleCreateNavigational = () => {
    navigate("/home/navigational/create");
  };

  // Card Click - Navigate to update page
  const handleCardClick = (id, sourceTab = null) => {
    navigate(`/home/navigational/update/${id}`);
  };

  return (
    <NavigationalListComponent
      navigationalList={filteredList}
      loading={loading}
      searchValue={searchValue}
      onSearchChange={handleSearchChange}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      statusFilter={statusFilter}
      onStatusFilterChange={setStatusFilter}
      onCreateNavigational={handleCreateNavigational}
      onCardClick={handleCardClick}
      canPerformActions={canPerformActions}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(NavigationalListContainer);